var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlMiniGolfFilled = function SvgHtlMiniGolfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 11.5a2.326 2.326 0 0 1 1.537-1.984.5.5 0 0 1 .432.902c-.607.291-.969.7-.969 1.083 0 .709 1.232 1.5 3 1.5s3-.791 3-1.5c0-.64-1-1.347-2.5-1.479V11a.5.5 0 0 1-1 0V2.5a.5.5 0 0 1 .724-.448l3 1.5a.5.5 0 0 1 .055.863L6.502 6.267v2.751c2 .149 3.5 1.186 3.5 2.482 0 1.4-1.757 2.5-4 2.5C3.759 14 2 12.9 2 11.5Zm9-2a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
  })));
};
export default SvgHtlMiniGolfFilled;